angular.module('eStories.modals', [
    /*Modals without scope dependencies and ng-controller*/
    'ui.bootstrap'
])
    .service('ModalsModel', ['$uibModal', '$log', '$injector',

        function ($uibModal, $log, $injector) {

            var model = this;

            model.open = function (modalUrl, controller, controllerAs, modalId, resolveObj) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: modalUrl,
                    windowClass: modalId ? modalId + "WindowClass" : "modalWindowClass",
                    size: null,
                    controller: controller + ' as ' + controllerAs,
                    resolve: resolveObj
                });

                return modalInstance;
            };

            model.openGiftRedeemModal = function (modalUrl, controller, controllerAs, modalId, resolveObj) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: modalUrl,
                    windowClass: modalId ? modalId + "WindowClass" : "modalWindowClass",
                    size: null,
                    controller: controller + ' as ' + controllerAs,
                    resolve: resolveObj,
                    backdrop: "static"
                });

                return modalInstance;
            };

            model.close = function (modalId) {
                $injector.get('$uibModalInstance').close(modalId);
            };

        }]);
